<template>
  <eDialog
    ref="elDialog"
    dialog-title="选择商品"
    :show-btn="false"
    :center-dialog-visible="visible"
    :popup-width="'900px'"
    @updateVisible="resetPopupData"
    @resetPopupData="resetPopupData"
    @submitPopupData="submitPopupData"
  >
    <div class="jc-dialog">
      <ESearch
        :data="listQuery"
        :field-list="fieldList"
        :list-type-info="{}"
        @handleFilter="handleFilter"
        @handleReset="handleReset"
      ></ESearch>

      <ETableList
        :table-data="tableData"
        :table-label="tableLabel"
        max-height="300"
        style="margin-top: 10px"
      >
        <template #goodsInfo="{ scope: { row } }">
          <div class="product-info">
            <img class="product-img" :src="row.defaultimage" alt />
            <div class="product-info-right">
              <div v-if="row.skuname.length < 48" class="title two-line">
                {{ row.skuname }}
              </div>
              <el-tooltip
                v-else
                class="item"
                effect="dark"
                :content="row.skuname"
                placement="top"
              >
                <div class="title two-line">{{ row.skuname }}</div>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                :content="row.skucode"
                placement="bottom"
              >
                <div class="num break">单品编号：{{ row.skucode }}</div>
              </el-tooltip>
              <div v-if="row.suppliercompanyname.length < 11" class="provider">
                供应商：{{ row.suppliercompanyname }}
              </div>
              <el-tooltip
                v-else
                class="item"
                effect="dark"
                :content="row.suppliercompanyname"
                placement="top"
              >
                <div class="provider break">
                  供应商：{{ row.suppliercompanyname }}
                </div>
              </el-tooltip>
            </div>
          </div>
        </template>
        <template #deliverTime="{ scope: { row } }">
          <span>{{ row.delivertime }}天内发货</span>
        </template>
        <template #price="{ scope: { row } }">
          <div
            v-if="row.price && row.pricetype === 4"
            class="jc-price-container"
          >
            <img
              height="20"
              width="44"
              src="../../../../../assets/img/product/together-price-icon-small@2x.png"
              alt="集采价"
            />
            <div class="jc-price">
              ￥
              <span>{{ moneyToFixed(row.price) }}</span>
            </div>
          </div>
          <span v-else style="color: #f0250f">¥ {{ row.price }}</span>
        </template>
        <template #operate="{ scope: { row } }">
          <eui-btn type="weak" @click="handleSelected(row)">选中</eui-btn>
        </template>
      </ETableList>
      <el-pagination
        style="margin-top: 20px"
        :pager-count="5"
        :page-sizes="[10, 20, 30]"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="listQuery.pageNum"
        :total="total"
        :page-size.sync="listQuery.pageSize"
        prev-text="上一页"
        next-text="下一页"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
  </eDialog>
</template>

<script>
import eDialog from '@/modules/projectA/components/common/e-dialog';
import ESearch from '@/modules/projectA/components/common/e-search';
import ETableList from '@/modules/projectA/components/common/e-table-list';

import Api from '@/modules/projectA/api/purchase/index';

export default {
  components: { eDialog, ESearch, ETableList },
  props: {
    visible: Boolean,
    records: {
      type: Object,
      default: () => {
        return {};
      },
    },
    routeData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    purchaseRow: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      tableLabel: [
        {
          label: '商品信息',
          minWidth: '280',
          align: 'center',
          slot: 'goodsInfo',
        },
        {
          label: '品牌',
          param: 'brandname',
          width: '120',
          align: 'center',
        },
        {
          label: '发货时间',
          width: '110',
          align: 'center',
          slot: 'deliverTime',
        },
        {
          label: '单位',
          param: 'unitvalue',
          width: '90',
          align: 'center',
        },
        {
          label: '含税价格（元）',
          width: '200',
          align: 'center',
          slot: 'price',
        },
        {
          label: '操作',
          width: '110',
          align: 'center',
          slot: 'operate',
          fixed: 'right',
        },
      ],
      tableData: [],
      listQuery: {
        suppliercompanyname: '',
        skuname: '',
        skucode: '',
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
      fieldList: [
        {
          label: '供应商名称',
          type: 'input',
          value: 'suppliercompanyname',
        },
        {
          label: '商品名称',
          type: 'input',
          value: 'skuname',
        },
        {
          label: '商品编码',
          type: 'input',
          value: 'skucode',
        },
      ],
    };
  },
  computed: {},
  mounted() {
    /* console.log(this.$refs.elDialog);
    this.$refs.elDialog.$refs.dialogRef.$el.firstChild.style.height = '660px'; */
    this.cloneQuery = this.$options.data().listQuery;
    this.queryEpecPriceByPage();
  },
  methods: {
    moneyToFixed(num) {
      return num.toFixed(2);
    },
    submitPopupData() {},
    // 协议的商品
    async queryEpecPriceByPage() {
      const params = {
        agreementId: this.records.protocolId,
        skuName: this.listQuery.skuname, // 精确查
        skuCode: this.listQuery.skucode, // 商品编号
        supplierCompanyName: this.listQuery.suppliercompanyname,
        pageSize: 10,
        pageNum: this.listQuery.pageNum,
        supplierCompanyId: this.records.supplierCompanyId,
      };
      const res = await Api.queryEpecPriceByPage(params);
      console.log(res, '水电费第三方第三方');
      if (res.code === '200') {
        const skuIds = res.data.records.map((item) => item.skuId);
        if (skuIds.length) {
          this.total = res.data.total;
          this.queryProductPage2Data(skuIds);
        } else {
          this.tableData = [];
        }
      }
    },
    async queryProductPage2Data(skuIds) {
      const params = {
        pageNum: 1,
        pageSize: 10,
        skuIds,
      };
      const res = await Api.queryProductPage2(params);
      this.tableData = [...res.data.list];
    },
    async handleSelected(val) {
      const userInfo = this.$store.state.USERINFO;
      // 获得税率信息
      const param = {
        taxRateId: val.taxrateid,
      };
      const res1 = await Api.getProductRate(param);

      if (res1.code === '200') {
        this.taxInfo = res1.data;

        const params = {
          brandName: val.brandname, // 品牌
          categoryId: val.categoryid, // 商品类目ID
          categoryName: val.category, // 商品类目名称
          price: val.price, // 商品价格
          productId: val.productid, // 商品id
          productImageUrl: val.defaultimage, // 商品图片
          productSkuCode: val.skucode, // 货品编号
          productSkuId: val.skuid, // 货品ID
          productSkuName: val.skuname, // 商品名称
          productSkuOptions: val.specificationsList, // 规格字符串 数组
          productSkuOptionsStr: val.specificationstr, // 规格字符串 拼接
          conversionUnitRatio: '', // 计量单位转换比率
          salesTaxNo: this.taxInfo.taxRateCode, // 销售税码
          salesTaxRate: this.taxInfo.taxRate, // 销售税率
          supplierCompanyId: val.suppliercompanyid, // 供应商公司id
          supplierCompanyName: val.suppliercompanyname, // 供应商公司名称
          purchaseCompanyId: this.routeData.purchaseCompanyId, // 采购商id
          purchaseCompanyName: this.routeData.purchaseCompanyName, // 采购商名称
          unitName: val.unitvalue, // 商品计量单位名称
          createMemberId: userInfo.memberId, // 申请人ID
          createMemberName: userInfo.memberName, // 申请人真实姓名
          createTime: this.records.createTime, // 创建时间
          protocolCode: this.records.protocolCode, // 协议编码
          protocolId: this.records.protocolId, // 协议ID
          purchasePlanId: this.routeData.purchasePlanId, // 采购计划id
          purchasePlanItemId: this.purchaseRow.purchasePlanItemId, // 采购计划物料明细id
          purchaseQuantity: this.purchaseRow.quantity, // 采购数量
          subtotal: this.purchaseRow.quantity * val.price, // 小计
          unitCode: '', // 商品计量单位编码
          purchasePlanItemSkuId: val.skuid, // 采购计划商品明细id
          deleteStatus: '', // 删除标记 默认 0：有效 1：删除
          updateMemberId: userInfo.memberId, // 申请人ID
          updateMemberName: userInfo.memberName, // 申请人真实姓名
          updateTime: '', // 修改时间
        };
        const res = await Api.checkPlanItemSku(params);
        if (res.code === '200') {
          this.$emit('getOrderList');
          this.resetPopupData();
        }
      }
    },
    handleReset() {
      this.listQuery = { ...this.cloneQuery };
      this.queryEpecPriceByPage();
    },
    handleFilter(val) {
      this.listQuery = { ...val };
      this.listQuery.pageNum = 1;
      this.listQuery.pageSize = 10;
      this.queryEpecPriceByPage();
    },
    handleCurrentChange(val) {
      this.listQuery.pageNum = val;
      this.queryEpecPriceByPage();
    },
    handleSizeChange(val) {
      this.listQuery.pageNum = 1;
      this.listQuery.pageSize = val;
      this.queryEpecPriceByPage();
    },
    resetPopupData() {
      this.$emit('update:visible', false);
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/theme.scss';
::v-deep .jc-price-container {
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  img {
    position: relative;
    z-index: 1;
  }
  .jc-price {
    height: 18px;
    padding: 0 10px 0 20px;
    margin-left: -20px;
    align-self: flex-end;
    background: #ffeac9;
    line-height: 18px;
    font-size: 14px;
    font-weight: 400;
    border-radius: 4px;
    color: #f0250f;
  }
}
::v-deep .product-info {
  position: relative;
  display: flex;
  align-items: center;
  width: 280px;
  margin-left: 10px;

  .product-img {
    width: 70px;
    height: 70px;
    border: 1px solid #e2e2e2;
    box-sizing: border-box;
  }

  .product-img-icon {
    position: absolute;
    top: 11px;
    left: 6px;
    width: 20px;
    height: 20px;
  }

  .product-info-right {
    display: flex;
    flex-direction: column;
    margin-left: 10px;
    overflow: hidden;

    .two-line {
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }

    > div {
      align-self: flex-start;
    }

    .title {
      width: 208px;
      text-align: left;
      color: #333333;
      line-height: 1;
      margin-bottom: 8px;
    }

    .num {
      color: #999999;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 208px;
      font-size: 12px;
      line-height: 1;
      text-align: left;
    }

    .provider {
      margin-top: 8px;
      font-size: 12px;
      color: #999999;
      text-align: left;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 208px;
      line-height: 1;
    }

    .footer {
      display: flex;
      justify-content: flex-start;

      p {
        width: 48px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        color: #ffffff;
        margin-left: 10px;
        border-radius: 5px;
        font-size: 14px;
      }

      .authenticated {
        background-color: $button-background-color;
      }

      .easy-all-pass {
        background-color: $button-background-color2;
      }
    }
  }
}
</style>
